<app-template>

  <app-breadcrumb>
    <li class="breadcrumb-item">
      <a [routerLink]="['/dashboard']">Home</a>
    </li>
    <li class="breadcrumb-item">My Requests</li>
  </app-breadcrumb>

  <div class="requests-header-sticky">
    <div class="all-requests-header d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
      <div class="d-flex align-items-center small text-muted">
        <span *ngIf="activeTab() === 'raised'">
          Showing
          <strong>{{ requestCount() }}</strong>
          raised requests
        </span>
        <span *ngIf="activeTab() === 'assigned'">
          Showing
          <strong>{{ requestCount() }}</strong>
          assigned requests
        </span>
      </div>

      <div class="d-flex align-items-center gap-2 flex-wrap">
        <button mat-raised-button color="primary" type="button" class="d-flex align-items-center gap-2 px-3 py-2"
          (click)="raiseRequests()">
          <mat-icon>add_circle</mat-icon>
          Raise a Request
        </button>

        <mat-chip-set aria-label="Request Tabs" class="mb-0 request-tabs">
          <mat-chip-option [selected]="activeTab() === 'raised'" (click)="onTabChange('raised')"
            class="px-2 custom-chip">
            Raised By Me
          </mat-chip-option>
          <mat-chip-option [selected]="activeTab() === 'assigned'" (click)="onTabChange('assigned')"
            class="px-2 custom-chip">
            Assigned To Me
          </mat-chip-option>
        </mat-chip-set>

        <mat-slide-toggle color="primary" class="view-switch" [checked]="viewMode() === 'list'"
          (change)="onViewToggle($event.checked)">
          Table view
        </mat-slide-toggle>
      </div>
    </div>

    <form [formGroup]="filterForm" (ngSubmit)="onApplyFilter()">
      <div class="card filter-card mb-3">
        <div class="card-body py-3">
          <div class="filter-toolbar">
            <button mat-icon-button color="primary" type="submit" matTooltip="Apply filter" aria-label="Apply filter">
              <mat-icon>filter_alt</mat-icon>
            </button>
          </div>

          <div class="filter-grid">
            <div class="filter-grid__item">
              <app-searchable-dropdown formControlName="account"
                [options]="accountList() | searchableOptions:'project_name':'account_id':'All'"
                placeholder="Select Project" class="w-100 filter-dropdown"></app-searchable-dropdown>
            </div>

            <div class="filter-grid__item">
              <app-searchable-dropdown formControlName="status"
                [options]="statusList() | searchableOptions:'status':'status_id':'All'" placeholder="Select Status"
                class="w-100 filter-dropdown"></app-searchable-dropdown>
            </div>

            <div class="filter-grid__item">
              <app-searchable-dropdown formControlName="category"
                [options]="categoryList() | searchableOptions:'issue_category':'issue_category_id':'All'"
                placeholder="Select Category" class="w-100 filter-dropdown"></app-searchable-dropdown>
            </div>

            <div class="filter-grid__item" *ngIf="showSubCategoryFilter()">
              <app-searchable-dropdown formControlName="sub_category"
                [options]="subCategoryList() | searchableOptions:'issue_category':'issue_category_id':'All'"
                placeholder="Sub Category" class="w-100 filter-dropdown"></app-searchable-dropdown>
            </div>

            <div class="filter-grid__item">
              <app-searchable-dropdown formControlName="priority"
                [options]="priorityList() | searchableOptions:'priority':'priority_id':'All'" placeholder="Priority"
                class="w-100 filter-dropdown"></app-searchable-dropdown>
            </div>

            <div class="filter-grid__item">
              <app-searchable-dropdown formControlName="wing"
                [options]="wingList() | searchableOptions:'block_name':'block_id':'All'" placeholder="Wing (Block)"
                class="w-100 filter-dropdown"></app-searchable-dropdown>
            </div>

            <div class="filter-grid__item">
              <app-searchable-dropdown formControlName="floor"
                [options]="floorList() | searchableOptions:'floor_name':'floor_id':'All'" placeholder="Floor"
                class="w-100 filter-dropdown"></app-searchable-dropdown>
            </div>

            <div class="filter-grid__item">
              <app-searchable-dropdown formControlName="unit_type"
                [options]="unitTypeList() | searchableOptions:'unit_type':'unit_type':'All'" placeholder="Unit Type"
                class="w-100 filter-dropdown"></app-searchable-dropdown>
            </div>

            <div class="filter-grid__item">
              <app-searchable-dropdown formControlName="unit"
                [options]="unitList() | searchableOptions:'floor_unit':'floor_unit_id':'All'" placeholder="Unit"
                class="w-100 filter-dropdown"></app-searchable-dropdown>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <ng-template #raisedRowActions let-row>
    <div class="d-flex align-items-center gap-1 flex-nowrap">
      <button *ngIf="canUpdateStatus(row)" (click)="openUpdateStatus(row); $event.stopPropagation()" mat-icon-button
        color="primary" matTooltip="Update status" aria-label="Update status">
        <mat-icon>update</mat-icon>
      </button>
      <button *ngIf="canEditRequest(row)" (click)="openEditDialog(row); $event.stopPropagation()" mat-icon-button
        color="primary" matTooltip="Edit issue / Assign" aria-label="Edit issue">
        <mat-icon>edit</mat-icon>
      </button>
      <button (click)="openAddIuusePhoto(row.issue_id); $event.stopPropagation()" mat-icon-button matTooltip="Add photo"
        aria-label="Add photo">
        <mat-icon>add_a_photo</mat-icon>
      </button>
      <button (click)="openComments(row.issue_id); $event.stopPropagation()" mat-icon-button matTooltip="Comments"
        aria-label="Open forum">
        <mat-icon>forum</mat-icon>
      </button>
    </div>
  </ng-template>

  <ng-template #assignedRowActions let-row>
    <div class="d-flex align-items-center gap-1 flex-nowrap">
      <button *ngIf="canUpdateStatus(row)" (click)="openUpdateStatus(row); $event.stopPropagation()" mat-icon-button
        color="primary" matTooltip="Update status" aria-label="Update status">
        <mat-icon>update</mat-icon>
      </button>
      <button *ngIf="canEditRequest(row)" (click)="openEditDialog(row); $event.stopPropagation()" mat-icon-button
        color="primary" matTooltip="Edit issue / Assign" aria-label="Edit issue">
        <mat-icon>edit</mat-icon>
      </button>
      <button (click)="openComments(row.issue_id); $event.stopPropagation()" mat-icon-button matTooltip="Comments"
        aria-label="Open forum">
        <mat-icon>forum</mat-icon>
      </button>
    </div>
  </ng-template>

  <div *ngIf="loading()" class="d-flex justify-content-center my-5">
    <div class="spinner-border text-secondary" role="status"></div>
  </div>

  <div *ngIf="!loading() && currentRequests().length === 0" class="text-center text-muted my-5">
    <span *ngIf="activeTab() === 'raised'">No raised requests found.</span>
    <span *ngIf="activeTab() === 'assigned'">No assigned requests found.</span>
  </div>

  <div class="requests-table-container"
    *ngIf="currentRequests().length > 0 && viewMode() === 'list' && activeTab() === 'raised'">
    <app-custom-table-view [columns]="tableColumns" [data]="tableData()" [loading]="loading()"
      [showDefaultActions]="false" [actionsTemplate]="raisedRowActions" [showSearch]="true" [rowClickable]="false"
      [showPagination]="true" [serverSidePagination]="true" [totalCount]="totalCount()"
      [itemsPerPage]="cardItemsPerPage()" [currentPage]="cardCurrentPage()"
      [pageSizeOptions]="[10, 20, 50, 100, 250, 500]" (pageChange)="onTablePageChange($event)"
      exportFileName="raised-by-me.xlsx" (export)="exportTableToExcel($event, 'raised-by-me.xlsx')"
      (refresh)="fetchMyIssues()"></app-custom-table-view>
  </div>

  <div class="requests-table-container"
    *ngIf="currentRequests().length > 0 && viewMode() === 'list' && activeTab() === 'assigned'">
    <app-custom-table-view [columns]="tableColumns" [data]="tableData()" [loading]="loading()"
      [showDefaultActions]="false" [actionsTemplate]="assignedRowActions" [showSearch]="true" [rowClickable]="false"
      [showPagination]="true" [serverSidePagination]="true" [totalCount]="totalCount()"
      [itemsPerPage]="cardItemsPerPage()" [currentPage]="cardCurrentPage()"
      [pageSizeOptions]="[10, 20, 50, 100, 250, 500]" (pageChange)="onTablePageChange($event)"
      exportFileName="assigned-to-me.xlsx" (export)="exportTableToExcel($event, 'assigned-to-me.xlsx')"
      (refresh)="fetchMyIssues()"></app-custom-table-view>
  </div>

  <div class="row g-3" *ngIf="!loading() && currentRequests().length > 0 && viewMode() === 'card'">
    <div class="col-sm-6 col-md-4 col-lg-3"
      *ngFor="let issue of currentRequests(); let index = index; trackBy: trackByIssueId">
      <div class="card h-100 shadow-sm border-0 issue-card">

        <div class="ratio ratio-4x3 issue-card-image">
          <img *ngIf="issue.issuePhotos && issue.issuePhotos.length > 0; else noImage"
            [src]="storageUrl + '/' + issue.issuePhotos[0]" class="card-img-top object-fit-cover" alt="Issue image" />
          <ng-template #noImage>
            <img src="assets/Images/dummy_imge.jpg" class="card-img-top object-fit-cover" alt="No Image Available" />
          </ng-template>
        </div>

        <div class="card-body d-flex flex-column issue-card-body">
          <h6 class="card-title mb-1 text-truncate issue-title">
            {{ issue.category_name || issue.account_name }}
          </h6>

          <small class="text-muted d-block mb-1">
            {{ issue.created_at | date: 'MMM d' }} • Wing {{ issue.block }} · Unit {{ issue.floor_unit }}
          </small>

          <div class="d-flex flex-wrap gap-1 mb-2 issue-badges">
            <span *ngIf="issue.priority_id" class="badge rounded-pill px-3 py-1" [ngClass]="{
                'bg-danger text-white': issue.priority_id === 1,
                'bg-light text-dark': issue.priority_id !== 1
              }">
              {{ issue.priority_name }}
            </span>

            <span class="badge rounded-pill bg-light text-secondary px-3 py-1">
              {{ issue.status_name }}
            </span>

            <span class="badge rounded-pill bg-light text-secondary px-3 py-1" *ngIf="issue.account_name">
              {{ issue.account_name }}
            </span>
          </div>

          <p class="card-text small text-muted mb-0 flex-grow-1 issue-description-clamp">
            {{ issue.description }}
          </p>
        </div>

        <div class="card-footer bg-white border-0 pt-0 issue-card-footer">
          <div class="d-flex align-items-center">
            <div class="d-flex align-items-center me-auto">
              <div
                class="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center me-1 issue-avatar"
                [matTooltip]="issue.reported_name || ''">
                {{ issue.reported_name?.charAt(0) }}
              </div>

              <div *ngIf="issue.assigned_to_name && activeTab() === 'assigned'"
                class="rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center issue-avatar-secondary"
                [matTooltip]="issue.assigned_to_name || ''">
                {{ issue.assigned_to_name.charAt(0) }}
              </div>
            </div>

            <div class="d-flex align-items-center gap-2">
              <button *ngIf="canUpdateStatus(issue)" (click)="openUpdateStatus(issue)" mat-icon-button color="primary"
                matTooltip="Update status" aria-label="Update status">
                <mat-icon>update</mat-icon>
              </button>

              <button *ngIf="canEditRequest(issue)" mat-icon-button color="primary" (click)="openAssignToDialog(issue)"
                aria-label="Edit request / Assign">
                <mat-icon>edit</mat-icon>
              </button>

              <ng-container *ngIf="activeTab() === 'raised'">
                <button (click)="openAddIuusePhoto(issue.issue_id)" mat-icon-button aria-label="Add photo">
                  <mat-icon>add_a_photo</mat-icon>
                </button>
              </ng-container>

              <button (click)="openComments(issue.issue_id)" mat-icon-button aria-label="Open forum">
                <mat-icon>forum</mat-icon>
              </button>
            </div>
          </div>

          <div *ngIf="issue.latest_comment" class="mt-2 border-top pt-2">
            <span class="small d-block">
              {{ issue.commented_by }} · {{ issue.commented_at | date:'dd MMM yyyy, h:mm a' }}
            </span>
            <span class="small">{{ issue.latest_comment }}</span>
          </div>
        </div>

      </div>
    </div>

    <!-- Card Pagination -->
    <div class="pagination mt-3" *ngIf="currentRequests().length > 0">
      <div class="items-per-page">
        Items per page:
        <select [ngModel]="cardItemsPerPage()" (ngModelChange)="onCardItemsPerPageChange($event)">
          <option [value]="50">50</option>
          <option [value]="100">100</option>
          <option [value]="250">250</option>
          <option [value]="500">500</option>
        </select>
      </div>
      <div class="page-info">
        {{ cardPageRangeStart() }} - {{ cardPageRangeEnd() }} of {{ displayFilteredCount() }} - {{ totalCount() ||
        displayFilteredCount() }}
      </div>
      <div class="page-navigation">
        <button type="button" (click)="cardPreviousPage()" [disabled]="!cardHasPreviousPage()">&lt;</button>
        <button type="button" (click)="cardNextPage()" [disabled]="!cardHasNextPage()">&gt;</button>
      </div>
    </div>
  </div>
</app-template>